module.exports = __webpack_public_path__ + "distretto-news-preview.jpg?d94037280cefe647e4c699a78f7adb2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/distretto-news-preview.jpg
// module id = 173
// module chunks = 0